<template>
  <div ref="container" v-bind="{ ...$attrs }" class="resizable-container">
    <div v-if="rightResizer" class="resizer resizer-right" @mousedown="onRightResizerMouseDown" />
    <slot />
  </div>
</template>
<script>
const THRESHOLD_WIDTH_FOR_HIDDEN = 20;
export default {
  props: {
    defaultWidth: { type: String, default: '' },
    rightResizer: { type: Boolean, default: true },
  },
  emits: ['onResized', 'onHidden'],
  data() {
    return {
      initialPositionX: null,
      containerClientX: null,
    };
  },
  watch: {
    defaultWidth() {
      this.$refs.container.style.width = this.defaultWidth;
    },
  },
  mounted() {
    this.$refs.container.style.width = this.defaultWidth;
  },
  methods: {
    onRightResizerMouseDown(event) {
      this.initialPositionX = event.clientX;
      this.containerClientX = this.$refs.container.clientWidth;

      document.addEventListener('mousemove', this.mouseMoveHandler);
      document.addEventListener('mouseup', this.mouseUpHandler);
      document.body.style.userSelect = 'none';
      this.setIframePointerEvents('none');
    },
    mouseUpHandler(event) {
      this.pauseEvent(event);
      document.removeEventListener('mousemove', this.mouseMoveHandler);
      document.removeEventListener('mouseup', this.mouseUpHandler);
      document.body.style.userSelect = null;
      this.setIframePointerEvents(null);
      this.$emit('onResized', this.$refs.container.style.width);
    },
    mouseMoveHandler(event) {
      this.pauseEvent(event);
      const dx = event.clientX - this.initialPositionX;
      const width = this.containerClientX + dx;
      this.$refs.container.style.width = `${width}px`;

      if (width < THRESHOLD_WIDTH_FOR_HIDDEN) {
        this.$emit('onHidden');
      }
    },
    pauseEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      e.cancelBubble = true;
      e.returnValue = false;
      return false;
    },
    setIframePointerEvents(value) {
      const iframeElements = document.querySelectorAll('iframe');
      iframeElements.forEach(element => {
        element.style.pointerEvents = value;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.resizable-container {
  --resizer-color: var(--color-grey-light);

  position: relative;
}

.resizer {
  position: absolute;
  width: 15px;
  z-index: var(--resizer-z-index, 1);
  cursor: ew-resize;

  &::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 100%;
    background-color: var(--resizer-color);
    transition-property: width, background-color;
    transition-duration: 0.2s;
    transition-timing-function: var(--ease-in-out);
  }

  &:is(:hover, :focus)::before {
    width: 6px;
    left: 0;
    background-color: var(--color-grey-base);
  }

  &.resizer-right {
    top: 0;
    right: -15px;
    height: 100%;
  }
}
</style>
